export default __webpack_public_path__ + "static/media/phoneHalf.03302c44.png";